import { render, staticRenderFns } from "./GElementCover.vue?vue&type=template&id=611c9e32&scoped=true&"
import script from "./GElementCover.vue?vue&type=script&lang=js&"
export * from "./GElementCover.vue?vue&type=script&lang=js&"
import style0 from "./GElementCover.vue?vue&type=style&index=0&id=611c9e32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611c9e32",
  null
  
)

export default component.exports